import * as React from "react";
import {ISubmissionProps} from "../utils/models";
import FoodBanks from "./FoodBanks";
import CharitableOrganisations from "./CharitableOrganisations";
import Warehouses from "./Warehouses";
import Beneficiaries from "./Beneficiaries";
import BeneficiariesPie from "./BeneficiariesPie";
import {useEffect, useState} from "react";
import Loader from "../../../shared/Loader";
import {getSurveySubmissions} from "../utils/submissions";

const FoodBank = ({container, selectedUoa, selectedYear, survey}: ISubmissionProps) => {
    const [loading, setLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);

    const getSurveysData = async () => {
        setLoading(true)

        if (survey) {
            const data = await getSurveySubmissions({container, survey_id: survey, selectedUoa, selectedYear})
            setSubmissions(data)
        }
    }

    useEffect(() => {
        getSurveysData().then(() => setLoading(false));
    }, [selectedUoa, selectedYear]);

    return (
        <>
            {
                !loading && (
                    <>
                        <div className="content-title col-span-2">
                            Overview
                        </div>
                        <div className="space-y-4">
                            <FoodBanks submissions={submissions}/>
                            <CharitableOrganisations submissions={submissions}/>
                            <Warehouses submissions={submissions}/>
                        </div>
                        <div className="content-title col-span-2">
                            End beneficiaries
                        </div>
                        <div className="space-y-4">
                            <Beneficiaries submissions={submissions}/>
                            <BeneficiariesPie submissions={submissions}/>
                        </div>
                    </>
                )
            }
            {
                loading && (
                    <div className="loader-container col-span-2">
                        <Loader size={60}/>
                    </div>
                )
            }
        </>
    );
}

export default FoodBank;